export class Recurso {
	id: number;
	item_1: number;
	item_1_obs: string;
	item_2: number;
	item_2_obs: string;
	nova_nota_1: number;
	item_1_just: string;
	nova_nota_2: number;
	item_2_just: string;
	trabalho_id: number;
	usuario_id: number;
}


// WEBPACK FOOTER //
// ./src/app/pedir-recurso/recurso.ts